import React from 'react';
import PropTypes from 'prop-types';
import './CategoryFilter.css';

const CategoryFilter = ({ 
  label = 'Filtrar:', 
  options = [], 
  selected, 
  onChange, 
  defaultOption = { label: 'Todos', value: 'all' } 
}) => {
  return (
    <div className="category-filter">
      <label htmlFor="category-select">{label}</label>
      <select
        id="category-select"
        value={selected}
        onChange={(e) => onChange(e.target.value)}
      >
        {defaultOption && (
          <option value={defaultOption.value}>{defaultOption.label}</option>
        )}
        {options.map((opt) => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </select>
    </div>
  );
};

CategoryFilter.propTypes = {
  label: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  selected: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  defaultOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
};

export default CategoryFilter;
